/*
 * @Author: cc
 * @Date: 2020-12-29 16:41:50
 * @LastEditTime: 2020-12-31 14:13:45
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\shortVideo\main.js
 * @Description: 短视频主模块 （包括抖音、快手）
 */
angular
    .module('editshortVideoModule', [
        'editshortVideoLeftModule',
        'EditShortVideoListModule',
        'editShortVideoNewDraftModule',
    ]).controller('EditingCenterTrillCtrl', [function () {

    }]);
